import t, { createContext as n, useContext as r, useMemo as e } from "react";
import i from "prop-types";
import l from "lodash/flatten";
import { injectGlobal as o, css as a, cx as h } from "@leafygreen-ui/emotion";
import { fontFamilies as g } from "@leafygreen-ui/tokens";
import s from "highlight.js/lib/core";
import c from "highlightjs-graphql";
import u from "highlight.js/lib/languages/javascript";
import f from "highlight.js/lib/languages/typescript";
import p from "highlight.js/lib/languages/csharp";
import m from "highlight.js/lib/languages/c-like";
import d from "highlight.js/lib/languages/go";
import b from "highlight.js/lib/languages/http";
import y from "highlight.js/lib/languages/ini";
import v from "highlight.js/lib/languages/java";
import j from "highlight.js/lib/languages/perl";
import k from "highlight.js/lib/languages/php";
import w from "highlight.js/lib/languages/python";
import O from "highlight.js/lib/languages/ruby";
import S from "highlight.js/lib/languages/rust";
import E from "highlight.js/lib/languages/scala";
import N from "highlight.js/lib/languages/swift";
import x from "highlight.js/lib/languages/kotlin";
import P from "highlight.js/lib/languages/objectivec";
import L from "highlight.js/lib/languages/bash";
import D from "highlight.js/lib/languages/shell";
import A from "highlight.js/lib/languages/sql";
import M from "highlight.js/lib/languages/yaml";
import q from "highlight.js/lib/languages/json";
import C from "highlight.js/lib/languages/diff";
import F from "highlight.js/lib/languages/xml";
import { uiColors as I } from "@leafygreen-ui/palette";

function T(t) {
  return (T = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  })(t);
}

function R(t, n, r) {
  return n in t ? Object.defineProperty(t, n, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = r, t;
}

function B() {
  return (B = Object.assign || function (t) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];

      for (var e in r) {
        Object.prototype.hasOwnProperty.call(r, e) && (t[e] = r[e]);
      }
    }

    return t;
  }).apply(this, arguments);
}

function J(t, n) {
  var r = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var e = Object.getOwnPropertySymbols(t);
    n && (e = e.filter(function (n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, e);
  }

  return r;
}

function z(t, n) {
  if (null == t) return {};

  var r,
      e,
      i = function (t, n) {
    if (null == t) return {};
    var r,
        e,
        i = {},
        l = Object.keys(t);

    for (e = 0; e < l.length; e++) {
      r = l[e], n.indexOf(r) >= 0 || (i[r] = t[r]);
    }

    return i;
  }(t, n);

  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(t);

    for (e = 0; e < l.length; e++) {
      r = l[e], n.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r) && (i[r] = t[r]);
    }
  }

  return i;
}

function G(t, n) {
  return n || (n = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(n)
    }
  }));
}

function H(t, n) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, n) {
    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
    var r = [],
        e = !0,
        i = !1,
        l = void 0;

    try {
      for (var o, a = t[Symbol.iterator](); !(e = (o = a.next()).done) && (r.push(o.value), !n || r.length !== n); e = !0) {
        ;
      }
    } catch (t) {
      i = !0, l = t;
    } finally {
      try {
        e || null == a.return || a.return();
      } finally {
        if (i) throw l;
      }
    }

    return r;
  }(t, n) || U(t, n) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function K(t) {
  return function (t) {
    if (Array.isArray(t)) return W(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
  }(t) || U(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function U(t, n) {
  if (t) {
    if ("string" == typeof t) return W(t, n);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? W(t, n) : void 0;
  }
}

function W(t, n) {
  (null == n || n > t.length) && (n = t.length);

  for (var r = 0, e = new Array(n); r < n; r++) {
    e[r] = t[r];
  }

  return e;
}

var X,
    Y = {
  javascript: u,
  typescript: f,
  csharp: p,
  clike: m,
  go: d,
  http: b,
  ini: y,
  java: v,
  perl: j,
  php: k,
  python: w,
  ruby: O,
  rust: S,
  scala: E,
  swift: N,
  kotlin: x,
  objectivec: P,
  bash: L,
  shell: D,
  sql: A,
  yaml: M,
  json: q,
  diff: C,
  xml: F
},
    $ = {
  JavaScript: "javascript",
  JS: "js",
  TypeScript: "typescript",
  TS: "ts",
  Csharp: "csharp",
  Cs: "cs",
  CLike: "clike",
  Go: "go",
  Http: "http",
  Ini: "ini",
  Java: "java",
  Perl: "perl",
  Php: "php",
  Python: "python",
  Ruby: "ruby",
  Rust: "rust",
  Scala: "scala",
  Swift: "swift",
  Kotlin: "kotlin",
  ObjectiveC: "objectivec",
  Bash: "bash",
  Shell: "shell",
  Sql: "sql",
  Yaml: "yaml",
  Json: "json",
  Graphql: "graphql",
  Diff: "diff",
  Xml: "xml"
},
    _ = {
  Light: "light",
  Dark: "dark"
},
    Q = function (t) {
  for (var n = 1; n < arguments.length; n++) {
    var r = null != arguments[n] ? arguments[n] : {};
    n % 2 ? J(Object(r), !0).forEach(function (n) {
      R(t, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : J(Object(r)).forEach(function (n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }

  return t;
}({}, $, {
  None: "none"
}),
    V = (R(X = {}, _.Light, {
  0: I.gray.light3,
  1: I.gray.light2,
  2: I.gray.dark2,
  3: I.gray.dark3,
  4: I.white,
  5: "#CA4821",
  6: "#EDB210",
  7: "#12824D",
  8: I.blue.dark2,
  9: I.blue.base,
  10: "#CC3887"
}), R(X, _.Dark, {
  0: I.black,
  1: I.gray.dark3,
  2: I.gray.light1,
  3: I.gray.light3,
  4: I.gray.dark2,
  5: "#FF6F44",
  6: "#EDB210",
  7: "#35DE7B",
  8: "#a5e3ff",
  9: "#2DC4FF",
  10: "#FF7DC3"
}), X);

function Z() {
  Object.values(_).forEach(function (t) {
    return o(function (t) {
      return "\n  .lg-highlight-hljs-".concat(t, " {\n    .lg-highlight-quote,\n    .lg-highlight-literal,\n    .lg-highlight-class,\n    .lg-highlight-section,\n    .lg-highlight-name,\n    .lg-highlight-class > .lg-highlight-keyword,\n    .lg-highlight-function > .lg-highlight-keyword {\n      color: ").concat(V[t][9], ";\n    }\n  \n    .lg-highlight-regexp,\n    .lg-highlight-params,\n    .lg-highlight-meta,\n    .lg-highlight-meta-string {\n      color: ").concat(V[t][8], ";\n    }\n  \n    .lg-highlight-comment {\n      color: ").concat(V[t][2], ";\n      font-style: italic;\n    }\n\n    .lg-highlight-doctag,\n    .lg-highlight-formula {\n      color: ").concat(V[t][3], ";\n    }\n  \n    .lg-highlight-keyword,\n    .lg-highlight-selector-tag,\n    .lg-highlight-selector-attr,\n    .lg-highlight-selector-pseudo,\n    .lg-highlight-selector-id,\n    .lg-highlight-selector-class {\n      color: ").concat(V[t][10], ";\n    }\n  \n    .lg-highlight-variable,\n    .lg-highlight-deletion,\n    .lg-highlight-symbol,\n    .lg-highlight-bullet,\n    .lg-highlight-subst,\n    .lg-highlight-meta,\n    .lg-highlight-link,\n    .lg-highlight-number,\n    .lg-highlight-attr,\n    .lg-highlight-attribute,\n    .lg-highlight-built_in,\n    .lg-highlight-template-variable,\n    .lg-highlight-type {\n      color: ").concat(V[t][5], "\n    }\n  \n    .lg-highlight-string,\n    .lg-highlight-addition,\n    .lg-highlight-title {\n      color: ").concat(V[t][7], ";\n    }\n  \n    .lg-highlight-emphasis {\n      font-style: italic;\n    }\n  \n    .lg-highlight-strong {\n      font-weight: bold;\n    }\n  }\n");
    }(t));
  });
}

var tt = n({
  highlightLines: [],
  darkMode: !1
});

function nt() {
  var t = G(["\n              display: inline-block;\n            "]);
  return nt = function nt() {
    return t;
  }, t;
}

function rt() {
  var t = G(["\n              padding-right: 24px;\n              user-select: none;\n              color: ", ";\n            "]);
  return rt = function rt() {
    return t;
  }, t;
}

function et() {
  var t = G(["\n    background-color: ", ";\n    background-image: ", ";\n\n    // Selects all children of a highlighted row, and adds a border top\n    & > td {\n      border-top: 1px solid ", ";\n    }\n\n    // Selects following rows after a highlighted row, and adds a border top\n    // We don't add border bottoms here to support consecutive highlighted rows.\n    & + tr > td {\n      border-top: 1px solid ", ";\n    }\n\n    // Remove borders between consecutive highlighted rows\n    & + & > td {\n      border-top: 0;\n    }\n\n    // If the highlighted row is the last child, then we add a border bottom\n    &:last-child > td {\n      border-bottom: 1px solid ", ";\n    }\n  "]);
  return et = function et() {
    return t;
  }, t;
}

function it() {
  var t = G(["\n  border-spacing: 0;\n  padding: 0;\n  vertical-align: top;\n\n  &:first-of-type {\n    padding-left: 12px;\n  }\n\n  &:last-of-type {\n    padding-right: 12px;\n  }\n"]);
  return it = function it() {
    return t;
  }, t;
}

function lt(n) {
  var r = n.kind,
      e = n.children,
      i = r ? "lg-highlight-".concat(r) : "";
  return t.createElement("span", {
    className: i
  }, e);
}

function ot(t) {
  return null != t && "object" === T(t) && !(t instanceof Array);
}

function at(t) {
  return null != t && "string" == typeof t;
}

function ht(n, r) {
  return null == n ? null : at(n) ? n : null != (e = n) && e instanceof Array ? n.map(ht) : ot(n) ? t.createElement(lt, {
    key: r,
    kind: n.kind
  }, ht(n.children)) : n;
  var e;
}

var gt = a(it());

function st(t) {
  var n, r, e;
  return t ? (n = "transparent", r = "linear-gradient(90deg, ".concat(I.gray.dark3, ", transparent)"), e = I.gray.dark3) : (n = I.yellow.light3, r = "none", e = I.yellow.light2), a(et(), n, r, e, e, e);
}

function ct(n) {
  var r = n.lineNumber,
      e = n.highlighted,
      i = n.darkMode,
      l = n.children,
      o = I.gray[i ? "dark1" : "light1"],
      g = i ? I.gray.light2 : I.yellow.dark2;
  return t.createElement("tr", {
    className: h(R({}, st(i), e))
  }, r && t.createElement("td", {
    className: h(gt, a(rt(), e ? g : o))
  }, r), t.createElement("td", {
    className: gt
  }, l));
}

function ut(n) {
  for (var e = n.lines, i = r(tt), l = i.highlightLines, o = i.showLineNumbers, h = i.darkMode, g = K(e); 0 === (null === (s = g[0]) || void 0 === s ? void 0 : s.length);) {
    var s;
    g.shift();
  }

  for (; 0 === (null === (c = g[g.length - 1]) || void 0 === c ? void 0 : c.length);) {
    var c;
    g.pop();
  }

  return t.createElement(t.Fragment, null, g.map(function (n, r) {
    var e,
        i = r + 1,
        g = l.includes(i);
    o && (e = i);
    var s = (null == n ? void 0 : n.length) ? n.map(ht) : t.createElement("div", {
      className: a(nt())
    });
    return t.createElement(ct, {
      key: i,
      lineNumber: e,
      darkMode: h,
      highlighted: g
    }, s);
  }));
}

var ft = {
  "after:highlight": function afterHighlight(n) {
    var r,
        e,
        i,
        l = n.emitter.rootNode;
    n.react = t.createElement(ut, {
      lines: (r = l.children, e = [], i = 0, null == e[i] && (e[i] = []), r.forEach(function (t) {
        at(t) && (t.includes("\n") ? t.split("").forEach(function (t) {
          if ("\n" === t) i++, e[i] = [];else {
            var n = e[i].length - 1;
            at(e[i][n]) ? e[i][n] += t : e[i].push(t);
          }
        }) : e[i].push(t)), ot(t) && e[i].push(t);
      }), e)
    });
  }
};

function pt() {
  var t = G(["\n            border-spacing: 0;\n            width: 100%;\n          "]);
  return pt = function pt() {
    return t;
  }, t;
}

function mt() {
  var t = G(["\n  color: inherit;\n  font-size: 13px;\n  font-family: ", ";\n  line-height: 24px;\n"]);
  return mt = function mt() {
    return t;
  }, t;
}

function dt(t) {
  return l(t.map(function (t) {
    return t instanceof Array ? function (t) {
      for (var n = H(K(t).map(function (t) {
        return Math.max(t, 0);
      }).sort(), 2), r = n[0], e = n[1], i = Math.min(r + 499, e), l = [], o = r; o <= i; o++) {
        l.push(o);
      }

      return l;
    }(t) : t;
  }));
}

function bt(t) {
  return "cs" !== t && "js" !== t && "ts" !== t;
}

var yt = !1;
var vt = a(mt(), g.code);

function jt(n) {
  var r = n.children,
      i = n.language,
      l = n.darkMode,
      o = void 0 !== l && l,
      g = n.showLineNumbers,
      u = void 0 !== g && g,
      f = n.highlightLines,
      p = void 0 === f ? [] : f,
      m = n.className,
      d = z(n, ["children", "language", "darkMode", "showLineNumbers", "highlightLines", "className"]);
  yt || function () {
    yt = !0, Z();
    var t = Object.values($).filter(bt);
    t.forEach(function (t) {
      "graphql" === t ? c(s) : s.registerLanguage(t, Y[t]);
    }), s.configure({
      languages: t,
      classPrefix: "lg-highlight-",
      tabReplace: "  "
    }), s.addPlugin(ft);
  }();
  var b = e(function () {
    return i === Q.None ? null : s.highlight(i, r, !0);
  }, [i, r]),
      y = null === b ? t.createElement(ut, {
    lines: r.split("\n").map(function (t) {
      return t ? [t] : [];
    })
  }) : b.react,
      v = o ? _.Dark : _.Light,
      j = dt(p);
  return t.createElement(tt.Provider, {
    value: {
      highlightLines: j,
      showLineNumbers: u,
      darkMode: o
    }
  }, t.createElement("code", B({}, d, {
    className: h("lg-highlight-hljs-".concat(v), vt, i, m)
  }), t.createElement("table", {
    className: a(pt())
  }, t.createElement("tbody", null, y))));
}

jt.displayName = "Syntax", jt.propTypes = {
  children: i.string.isRequired,
  language: i.oneOf(Object.values(Q)),
  className: i.string,
  darkMode: i.bool,
  showLineNumbers: i.bool,
  highlightLines: i.arrayOf(i.oneOfType([i.arrayOf(i.number), i.number]))
};
export default jt;
export { Q as Language, V as variantColors };